const _ = "cardWrapper_isi68", c = "card_bisLZ", r = "card__customerName_6mQ4H", a = "card__scanCodes_2guaj", d = "card__info_wRSGV", t = "card__info__rightSide_SYSBX", e = "card__info__title_ucXlC", o = "card__info__content_QgRlX", n = "card__prelude_Y--Ub", s = "terms_6pAcW", i = {
  cardWrapper: _,
  card: c,
  card__customerName: r,
  card__scanCodes: a,
  card__info: d,
  card__info__rightSide: t,
  card__info__title: e,
  card__info__content: o,
  card__prelude: n,
  terms: s
};
export {
  c as card,
  _ as cardWrapper,
  r as card__customerName,
  d as card__info,
  o as card__info__content,
  t as card__info__rightSide,
  e as card__info__title,
  n as card__prelude,
  a as card__scanCodes,
  i as default,
  s as terms
};
//# sourceMappingURL=loyaltyCard.module.scss.js.map
